import { connect } from 'react-redux';
import { AppState } from '../../root.reducer';
import { isLoadingSavedSearchSelector, isSearchingSelector, savedSearchSelector } from '../search.selectors';
import { SavedSearchPageComponent, SavedSearchPageStateProps, SavedSearchPageDispatchProps } from './SavedSearchPage.component';
import { Dispatch } from 'redux';
import { loadSavedSearch, loadSavedSearchSuccess, loadSavedSearchError } from '../search.actions';
import { searchService } from '../search.service';
import { RouteComponentProps } from 'react-router-dom';
import { gravityUseAsSelector } from '../../auth/authentication.selectors';
import { pageSelector } from '../../saved-companies/saved-companies.selectors';
import { pageNextAction, pagePreviousAction, resetCurrentPageAction } from '../../saved-companies/saved-companies.actions';
import { authenticationService } from '../../auth/authentication.service';
import { authenticationSuccessAction } from '../../auth/authentication.actions';
import { workspaceService } from '../../workspace-settings/workspace.service';
import { workspaceLoadedSuccessfulAction } from '../../workspace-settings/workspace.actions';

const mapStateToProps = (state: AppState, { match }: RouteComponentProps<{ id: string }>): SavedSearchPageStateProps => ({
    isLoadingSavedSearch: isLoadingSavedSearchSelector(state),
    savedSearch: savedSearchSelector(state),
    savedSearchId: Number(match.params.id),
    useGravityAs: gravityUseAsSelector(state),
    isSearching: isSearchingSelector(state),
    page: pageSelector(state)
});

const mapDispatchToProps = (dispatch: Dispatch, { history }: RouteComponentProps<{ id: string }>): SavedSearchPageDispatchProps => ({
    loadSavedSearch: async (id: number, page: number, useGravityAs?: number) => {
        dispatch(loadSavedSearch());

        try {
            if (useGravityAs) {
                const savedSearch = await searchService.loadSavedWorkspaceSearch(id, page - 1, 50);
                dispatch(loadSavedSearchSuccess(savedSearch));
                const workspace = await workspaceService.getWorkspaceSettings(useGravityAs);
                dispatch(workspaceLoadedSuccessfulAction(workspace));
            } else {
                const savedSearch = await searchService.loadSavedUserSearch(id, page - 1, 50);
                dispatch(loadSavedSearchSuccess(savedSearch));
                const user = await authenticationService.getUser();
                dispatch(authenticationSuccessAction(user));
            }
        } catch (e) {
            dispatch(loadSavedSearchError());
        }
    },

    nextPage: (maxPage: number) => {
        dispatch(pageNextAction(maxPage));
    },

    previousPage: () => {
        dispatch(pagePreviousAction());
    },

    resetCurrentPage: () => {
        dispatch(resetCurrentPageAction());
    }
});

export default connect<SavedSearchPageStateProps, SavedSearchPageDispatchProps, RouteComponentProps<{ id: string }>, AppState>(
    mapStateToProps,
    mapDispatchToProps
)(SavedSearchPageComponent);